import { API_ENDPOINTS } from '../constants/apiEndpoints';
import apiClient from './apiClient';

const getAll = async () => (await apiClient.get(API_ENDPOINTS.merchants.list)).data;
const getById = async (id) => (await apiClient.get(API_ENDPOINTS.merchants.details(id))).data;
const create = async (payload) => (await apiClient.post(API_ENDPOINTS.merchants.create, payload)).data;
const update = async (id, payload) => (await apiClient.put(API_ENDPOINTS.merchants.details(id), payload)).data;
const remove = async (id) => apiClient.delete(API_ENDPOINTS.merchants.details(id));

export const merchantService = { getAll, getById, create, update, remove };
